export async function getText(file) {
  const response = await fetch(file)
  const text = await response.text()
  return text
}
